import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const parkingLotExample: TemplateDefinition = {
  mode: "compose",
  slug: "parking-lot-example",
  version: 1,
  title: "Parking lot",
  description: "Locate empty spots",
  thumbnailUuid: BASE_ASSETS.parkingLotExample.uuid,
  assets: [BASE_ASSETS.parkingLotExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.parkingLotExample.uuid,
              extension: BASE_ASSETS.parkingLotExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: { type: "text", value: "Segment all empty parking spots." },
      },
    ],
    outputAnnotations: true,
    variables: {},
    annotationFormat: "box",
    enableThinking: false,
  } satisfies DocumentInputContentV1,
};
